import Painel from './painel/Painel';

// O painel do evento: uma tela só, abas pelo tipo de evento.
export default Painel;